export default "__VITE_ASSET__Bjsl7EGB__"